/**
 * CMCD request header name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_REQUEST = 'CMCD-Request';
//# sourceMappingURL=CMCD_REQUEST.js.map